export const GET_TEXTURE = "GET_TEXTURE";
export const GET_TEXTURE_SUCCESS = "GET_TEXTURE_SUCCESS";
export const GET_TEXTURE_ERROR = "GET_TEXTURE_ERROR";
